var _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBody3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: -118,
    cy: 186.5,
    rx: 442,
    ry: 422.5,
    fill: "#FCCFDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1769.96 317.903C1738.5 286.444 1738.5 235.438 1769.96 203.978L1955.98 17.9624C1987.44 -13.4971 2038.44 -13.4971 2069.9 17.9624V17.9624C2101.36 49.4219 2101.36 100.428 2069.9 131.887L1883.89 317.903C1852.43 349.363 1801.42 349.363 1769.96 317.903V317.903Z",
    fill: "#262D40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1608.81 299.751C1569.7 260.643 1569.7 197.237 1608.81 158.129L1896.13 -129.189C1935.24 -168.297 1998.64 -168.297 2037.75 -129.189V-129.189C2076.86 -90.081 2076.86 -26.6745 2037.75 12.4334L1750.43 299.751C1711.33 338.859 1647.92 338.859 1608.81 299.751V299.751Z",
    fill: "#D7EFF4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody3);
export default __webpack_public_path__ + "static/media/body_3.00b966a042f7e06ebd741d7bdec5963d.svg";
export { ForwardRef as ReactComponent };